import React, { useEffect, useState, useRef } from "react";
import {
  stopPlayingAudio,
  getUserToken,
} from "../../../Actions/Utils";
import {
  guideButtons,
  languagePreferenceConstant,
  codeToSvgName,
} from "../../../NewConstants/IntroductionConstants";
import { generateSpeech } from "../../../Actions/ChatActions";
import { useNavigate } from "react-router-dom";
import NextBtn from "../../../Shared/Components/NextBtn/NextBtn";
import {
  languagecheckHeading,
  languagecheckNextButton,
  languagecheckSubHeading,
  languageCheckSuccessMessage,
  languageCheckWelcomeMessage,
} from "../../../NewConstants/Language-Constants";
import { getUserCadre, getUserKb } from "../../../Actions/Utils";
import "./LanguageCheck.css";
import { getLanguages, setMessageLanguage } from "../../../Actions/UserActions";
import ToastMessage from "../../../Shared/Components/ToastMessage/ToastMessage";

const LanguageCheck = ({ selectedLanguage, setSelectedLanguage }) => {
  const [languages, setLanguages] = useState([]);
  const [loading, setLoading] = useState(true);
  const userProfileData = JSON.parse(localStorage.getItem("userProfileData"));
  const [showSpeakerIcon, setShowSpeakerIcon] = useState(true);
  const [showSpeakerActive, setShowSpeakerActive] = useState(false);
  const [showToastMessage,  setShowToastMessage] = useState(false);
  const [toastErrorMessage, setToastErrorMessage] = useState("");
  const audioRef = useRef(null);
  const navigate = useNavigate();
  const LANG_ICON_PATH = "/Assets/Images/Lang/";

  useEffect(() => {
    async function fetchLanguages() {
      setLoading(true);
      const res = await getLanguages(getUserCadre(), getUserKb());
      if (res?.status === 200 && res.data?.languages) {
        setLanguages(res.data.languages);
      } else {
        setLanguages([]);
      }
      setLoading(false);
    }
    fetchLanguages();
  }, []);

  useEffect(() => {
    if (selectedLanguage !== "en") {
        setSelectedLanguage("en");
    }
  }, []);

  useEffect(() => {
    const handleAudio = async () => {
      const res = await generateSpeech(
        languagePreferenceConstant[selectedLanguage],
        selectedLanguage
      );
      if (res?.data?.url) {
        const newAudio = new Audio(res?.data?.url);
        if (audioRef.current) {
          audioRef.current.pause();
        }
        newAudio.addEventListener("ended", () => {
          setShowSpeakerActive(false);
        });
        audioRef.current = newAudio;
        newAudio.play().catch((err) => {
          console.error("Error playing audio:", err);
        });
      } else {
        setToastErrorMessage(res?.data?.detail || "Audio error");
        setShowToastMessage(true);
        setShowSpeakerActive(false);
      }
    };
    if (showSpeakerActive && selectedLanguage) handleAudio();
  }, [showSpeakerActive, selectedLanguage]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      stopPlayingAudio(audioRef);
      setShowSpeakerActive(false);
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [audioRef]);

  const handleSelect = (code) => {
    setSelectedLanguage(code);
  };
  const handleSetMessageLanguage = async () => {
    const token = getUserToken();
    if (token) {
      const res = await setMessageLanguage(token, selectedLanguage, getUserCadre(), getUserKb());
      if (res?.status === 200) {
        navigate("/chat");
      } else {
        setToastErrorMessage(res?.data?.detail);
        setShowToastMessage(true);
      }
      if (res?.status === 401) {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/login");
      }
      if (res?.status === 500) {
        setToastErrorMessage(res?.data?.detail);
        setShowToastMessage(true);
      }
    } else {
      navigate("/login");
    }
  }

  return (
    <div
      className="w-full h-full flex flex-col items-center justify-start"
      style={{ backgroundImage: `url("/Assets/Images/bgWallpaper.svg")` }}
    >
      <div className="languageCheckContainer w-[90%] h-[full] mt-[1.5rem] flex flex-col items-center justify-center bg-white rounded-lg">
        <div className="w-full h-[3rem] mt-2 mb-2 pt-2 pb-2 flex items-center justify-end pr-4">
          <div
            className={`speakerDiv ${
              showSpeakerIcon && showSpeakerActive ? "Active" : ""
            }`}
            onClick={() => {
              setShowSpeakerActive(!showSpeakerActive);
              stopPlayingAudio(audioRef);
            }}
          >
            {showSpeakerIcon && showSpeakerActive
              ? guideButtons.stop[selectedLanguage]
              : null}
            {showSpeakerActive ? (
              <div>
                <img
                  src={"/Assets/Images/blueSpeaker.svg"}
                  alt="active Speaker"
                />
              </div>
            ) : (
              <div>
                <img
                  src={"/Assets/Images/crossSpeakerIcon.svg"}
                  alt="speaker"
                />
              </div>
            )}
          </div>
        </div>
        <div className="w-full h-[90%] flex flex-col items-center justify-center gap-4">
          <div className="languageCheckImageContainer w-full  flex flex-col items-center justify-center px-2">
            <img
              className="w-full h-full object-contain"
              src="/Assets/Images/Lady_Illustrations/Lang_check.svg"
              alt="languageCheck"
            />
          </div>
          <div className="flex flex-col items-center justify-center">
            <span
              className="text-l font-normal text-base"
              style={{ color: "var(--green-1)" }}
            >
              {languageCheckSuccessMessage[selectedLanguage]}
            </span>
            <span
              className="text-base font-bold text-xl"
              style={{ color: "var(--black)" }}
            >
              {languageCheckWelcomeMessage[selectedLanguage]}{" "}
              {userProfileData?.name}
            </span>
          </div>
          <div className="w-full h-full flex flex-col items-center justify-center gap-4">
            <div className="w-full h-full pl-4 flex flex-col items-start justify-center">
              <span
                className="text-lg"
                style={{ color: "var(--light-neutral-8)" }}
              >
                {languagecheckHeading[selectedLanguage]}
              </span>
              <span
                className="text-base"
                style={{ color: "var(--dark-neutral-2)" }}
              >
                {languagecheckSubHeading[selectedLanguage]}
              </span>
            </div>
            <div className="w-full h-full flex flex-wrap justify-center gap-9 mt-4">
              {loading ? (
                <div className="col-span-3 text-white">Loading...</div>
              ) : (
                languages.map((lang) => {
                  const isSelected = selectedLanguage === lang.value;
                  const engName = codeToSvgName[lang.value];
                  const svgFile = `${LANG_ICON_PATH}${engName} - ${
                    isSelected ? "White" : "Gray"
                  }.svg`;
                  return (
                    <div className="flex flex-col items-center justify-center">
                      <div
                        key={lang.label}
                        className={`flex flex-col items-center justify-center rounded-full cursor-pointer p-2 w-[4.91rem] h-[4.91rem]`}
                        onClick={() => handleSelect(lang.value)}
                        style={{
                          backgroundColor: isSelected
                            ? "var(--primary-dark)"
                            : "var(--light-neutral-2)",
                        }}
                      >
                        <img src={svgFile} alt={lang.label} />
                      </div>
                      <span
                        className={`text-base ${
                          selectedLanguage === lang.value
                            ? "font-bold text-var(--primary-dark)"
                            : " text-var(--light-neutral-8)"
                        }`}
                        style={{
                          color:
                            selectedLanguage === lang.value
                              ? "var(--primary-dark)"
                              : "var(--light-neutral-8)",
                        }}
                      >
                        {lang.label}
                      </span>
                    </div>
                  );
                })
              )}
            </div>
          </div>
          <div className="w-full h-full flex items-center justify-center mb-4 mt-4 ml-0 mr-0 px-2">
            <NextBtn
              value={languagecheckNextButton[selectedLanguage]}
              icon={"/Assets/Images/nextWhiteIcon.svg"}
              bgColor={"var(--primary-dark)"}
              color={"var(--neutral-white)"}
              nextClick={handleSetMessageLanguage}
              btnFullWidth={true}
              pady={7}
              textCenter={true}
            />
          </div>
        </div>
      </div>
      {showToastMessage && (
        <ToastMessage
          message={toastErrorMessage}
          direction={"bottom"}
          close={() => setShowToastMessage(false)}
        />
      )}
    </div>
  );
};

export default LanguageCheck;
